import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className='footer'>
<div className='row  margin container'>

<div className='col-lg-3 col-md-4'>
 <h5>MOZAHID HOUSE </h5>
 <p>Social Media Account</p>


 <div className='logo-fb'>
     <img className='' src="https://i.ibb.co/yPv669g/fffffffffbook.png" alt="sorry"></img>
     <img className='' src="https://i.ibb.co/9rXfykd/iiiiiiiiiiiiiiiiiiiiiiiiii.jpg" alt="sorry"></img>
     <img className='' src="https://i.ibb.co/y4NDpyW/mmmmmmmmmmmmmmmm.jpg" alt="sorry"></img>
     <img className='' src="https://i.ibb.co/bByLfGj/ttttttttttttttt.png" alt="sorry"></img>
 </div>

</div>

     <div className='col-lg-3  col-md-4 '>
        <h5>LINKES</h5>
        <p>Home<br/>
        Download<br/>
        Pricing<br/>
        About

        </p>
    </div>

<div className='col-lg-3   col-md-4'>
       <h5>PRODUCTS </h5>
        <p>Bed<br/>
        Sofa<br/>
        Lamp-Table<br/>
        Dining-Table

        </p>

</div>

<div className='col-lg-3  col-md-4'>
      <h5>SUPPORT </h5>
        <p>FAQ<br/>
        How at Work<br/>
        Featurs<br/>
        Contact

        </p>

</div>



</div>

        </div>
    );
};

export default Footer;